import { Directive, ElementRef, OnInit } from '@angular/core';
import { UiAdaptionVisiblePipe } from '@bo-client/shared/pipes/ui-adaption-value-pipe';

@Directive({
  selector: '[appAdaptionSuppressAutocomplete]'
})
export class AdaptionSuppressAutocompleteDirective implements OnInit {
  constructor(private elementRef: ElementRef, private adaptionVisiblePipe: UiAdaptionVisiblePipe) {}

  ngOnInit() {
    const result = this.adaptionVisiblePipe.transform('general.disableAddressAutocomplete');
    if (!result) return;
    // Timeout ist notwendig, da das matAutocomplete-Directive erst initialisiert werden muss
    setTimeout(() => {
      this.elementRef.nativeElement.setAttribute('autocomplete', 'one-time-code');
    });
  }
}
